import React from 'react';

import Loading from '@pb/kit-component-loading';

export const RequestsLoadingState: React.FC = () => (
    <div style={{display: 'flex', justifyContent: 'center', padding: '1rem 0'}}>
        <Loading fast={true}/>
    </div>
);
